import { Table, Tooltip, Flex } from "antd";
import { useMemo } from "react";
import styles from "./notices_subscriptions-table.module.css";

import TaskIcon from "@/icons/TaskIcon";
import CubIcon from "@/icons/CubIcon";

import CustomLink from "@/components/ui/CustomLink";

function getIcon(type) {
  switch (type) {
    case "task":
      return <TaskIcon />;
    case "object":
      return <CubIcon />;
    default:
      return null;
  }
}

function getName(type) {
  switch (type) {
    case "task":
      return "Задача";
    case "object":
      return "Ресурс";
    default:
      return "";
  }
}

const NoticesSubscriptionsTable = ({
  data,
  loading,
  pagination,
  onChange,
  showSelect = false,
  selectedRowKeys = [],
  onRowsSelect,
}) => {
  const columns = useMemo(
    () => [
      {
        title: "Раздел",
        dataIndex: "notification_type",
        key: "notification_type",
        width: 100,
        style: { verticalAlign: "middle" },
        ellipsis: { showTitle: true },
        render: (_, item) => (
          <Flex align="center" gap={6} className={styles.type_tag}>
            {getIcon(item.type)}
            <span>{getName(item.type)}</span>
          </Flex>
        ),
        sorter: {
          compare: (a, b) => (a.type || "").localeCompare(b.type || ""),
        },
      },
      {
        title: "Название",
        key: "name",
        width: 420,
        ellipsis: true,
        render: (_, item) => {
          const name =
            item.type === "task"
              ? `№${item.task_number} - ${item.item_name}`
              : `${item.definition_name} - ${item.item_name}`;
          const href = item.object_link
            ? item.object_link
            : item.type === "task"
            ? `/tasks/t-list/${item.item_uuid}`
            : `/my-objects/${item.definition_uuid}/${item.item_uuid}`;
          return href ? (
            <Tooltip placement="bottomLeft" title={name}>
              <CustomLink to={href} color="#0066A6">
                {name}
              </CustomLink>
            </Tooltip>
          ) : (
            <Tooltip placement="bottomLeft" title={name}>
              <span>{name}</span>
            </Tooltip>
          );
        },
        sorter: {
          compare: (a, b) =>
            (a.info?.object_name || "").localeCompare(
              b.info?.object_name || ""
            ),
        },
      },
    ],
    []
  );

  return (
    <>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="item_uuid"
        loading={loading}
        pagination={pagination}
        onChange={onChange}
        showSorterTooltip={{
          target: "sorter-icon",
          title: "Нажмите для сортировки",
        }}
        scroll={{ x: "100%" }}
        rowClassName="bottom-align"
        rowSelection={
          showSelect
            ? {
                type: "checkbox",
                selectedRowKeys,
                preserveSelectedRowKeys: true,
                onChange: (newSelectedRowKeys) => {
                  onRowsSelect(newSelectedRowKeys);
                },
              }
            : undefined
        }
      />
    </>
  );
};

export default NoticesSubscriptionsTable;
